import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function FeeHeadsPage(){return <ExtendedModulePage moduleKey="fee-heads"/>}
